
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { EstimationClient } from '@/services/Services';
import EditMechanicalEmbroideryMaterialCompositionModal from '../modals/editMechanicalEmbroideryMaterialCompositionModal.vue';
import * as OM from '@/Model';

@Options({
    components: {
    }
})
export default class MechanicalEmbroidery extends Vue {
    
    @Prop() estimationIdentifier: string;

    @Prop({
        default: false
    }) isReadOnly: boolean;

    mechanicalEmbroidery: OM.MechanicalEmbroidery = new OM.MechanicalEmbroidery();
    haveMechanicalEmbroidery: boolean = false;

    created() {
        EstimationClient.getMechanicalEmbroideryByEstimation(this.estimationIdentifier)
        .then(x => {
            this.mechanicalEmbroidery = x;

            if(this.mechanicalEmbroidery.materialsPercentage.length > 0)
                this.haveMechanicalEmbroidery = true;
        })
    }

    editMaterialsComposition() {
        this.$opModal.show(EditMechanicalEmbroideryMaterialCompositionModal, {
            availableMaterials: this.mechanicalEmbroidery.configuration.availableMaterials.map(x => x.key),
            materialsPercentage: this.mechanicalEmbroidery.materialsPercentage,
            saveCallback: (listUpdated: OM.KeyValuePairOfStringAndDouble[]) => {
                this.mechanicalEmbroidery.materialsPercentage = listUpdated;
                this.$opModal.closeLast();
            }
        })
    }

    removeEmbroiderySection() {
        this.mechanicalEmbroidery.materialsPercentage = [];
        this.createVMAndSave();
        this.haveMechanicalEmbroidery = false;
    }

    get totalCO2equFU() {
        var totalCO2equFU = 0;
        var materialCO2equFU = 0;

        this.mechanicalEmbroidery.materialsPercentage.forEach(kvp => {
            var materialKgUnit = this.mechanicalEmbroidery.configuration.availableMaterials.filter(x => x.key == kvp.key)[0]!.value;
            var quantityFU = (this.mechanicalEmbroidery.configuration.totalMaterial * kvp.value) / 100;
            materialCO2equFU += quantityFU * materialKgUnit;
        });

        if (materialCO2equFU > 0)
            totalCO2equFU = materialCO2equFU + this.mechanicalEmbroidery.configuration.totalProcessingPackaging + this.mechanicalEmbroidery.configuration.totalTransportation + this.mechanicalEmbroidery.configuration.totalDisposalPhase;
        else
            totalCO2equFU = 0;

        return totalCO2equFU;
    }

    get getTotal() {
        var threadTotalGCO2e = this.mechanicalEmbroidery.threadDensity * (this.mechanicalEmbroidery.threadLength / 100) * this.totalCO2equFU;
        var machineTotalEmissionGCO2e = this.mechanicalEmbroidery.machineWatt == 0 || this.mechanicalEmbroidery.machineRunTime == 0 ? 0 : (this.mechanicalEmbroidery.machineWatt/1000) * (this.mechanicalEmbroidery.machineRunTime/60/60) * 0.553;
        var total = threadTotalGCO2e == 0 ? 0 : threadTotalGCO2e + machineTotalEmissionGCO2e;

        return total;
    }

    createVMAndSave() {
        var vmModel = new OM.MechanicalEmbroideryUpdateVM();
        vmModel.estimationIdentifier = this.estimationIdentifier;
        vmModel.configurationIdentifier = this.mechanicalEmbroidery.configuration.identifier;
        vmModel.materialsPercentage = this.mechanicalEmbroidery.materialsPercentage;
        vmModel.threadDensity = this.mechanicalEmbroidery.threadDensity;
        vmModel.threadLength = this.mechanicalEmbroidery.threadLength;
        vmModel.machineWatt = this.mechanicalEmbroidery.machineWatt;
        vmModel.machineRunTime = this.mechanicalEmbroidery.machineRunTime;

        EstimationClient.updateMechanicalEmbroideryInfo(vmModel)
        .then(x => {
            console.log("Salvato con successo");
        })
    }

    @Watch('mechanicalEmbroidery.materialsPercentage')
    updateValue() {
        setTimeout(() => {
            this.createVMAndSave();
        }, 500);
    }

}
